/**
 * @flow
 * @format
 */

import _TableSelectionGroup from './TableSelectionGroup';

export default _TableSelectionGroup;



// WEBPACK FOOTER //
// ./src/components/TableSelectionGroup/index.js